/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMusicStreamingUrlRequest} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/music.pb'
import {GetMusicStreamingUrlResponse} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/music.pb'


export const getMusicStreamingUrl = (request: GetMusicStreamingUrlRequest, options?: CashRequestOptions) => post<GetMusicStreamingUrlRequest, GetMusicStreamingUrlResponse>("/2.0/cash/get-music-streaming-url", request, {...options, rejectOnError: true })